import { Link } from 'react-router-dom'

import { OpenInNewOutlined } from '@mui/icons-material'
import { IconButton, Tooltip } from '@collaborate-health/uikit'

export interface OpenInNewTabIconButtonProps {
  url: string
  disabled?: boolean
}

const OpenInNewTabIconButton: React.FC<OpenInNewTabIconButtonProps> = ({ disabled = false, url }) => {
  return (
    <Link to={url} target='_blank'>
      <Tooltip text='Open in new tab'>
        <span>
          <IconButton disabled={disabled} size='small' edge='end'>
            <OpenInNewOutlined />
          </IconButton>
        </span>
      </Tooltip>
    </Link>
  )
}

export default OpenInNewTabIconButton

